/**
 * MODULE: _shared/frontend-shell/src/features/crm/types/task.types.ts
 * PURPOSE: CRM task domain types for tasks board and schedule modal
 * DEPENDENCIES: None
 * PUBLIC_API: Task, TaskStatus, TaskPriority, TaskType, TASK_STATUS_LABELS, taskStatusDisplayLabel
 * SIDE_EFFECTS: None
 * AGENT_SAFETY: SAFE
 */

export type TaskStatus = 'todo' | 'in_progress' | 'done' | 'overdue';

/** Canonical UI copy for task status (board, filters, badges, schedule modal). */
export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  todo: 'To Do',
  in_progress: 'In Progress',
  done: 'Done',
  overdue: 'Overdue',
};

/** Resolve display label for a task status slug; returns input when not a known task status. */
export function taskStatusDisplayLabel(status: string): string {
  const k = String(status).trim().toLowerCase();
  if (k in TASK_STATUS_LABELS) return TASK_STATUS_LABELS[k as TaskStatus];
  return String(status).trim();
}

export type TaskPriority = 'low' | 'medium' | 'high' | 'urgent';
export type TaskType = 'call' | 'email' | 'meeting' | 'note' | 'task' | 'follow_up';

export interface Task {
  id: string;
  title: string;
  description?: string;
  type: TaskType;
  status: TaskStatus;
  priority: TaskPriority;
  ownerId: string;
  ownerName: string;
  ownerAvatarUrl?: string;
  relatedEntityId?: string;
  relatedEntityType?: 'contact' | 'account' | 'deal' | 'territory';
  relatedEntityName?: string;
  dueDateISO: string;
  completedAtISO?: string;
  createdAtISO: string;
  notes?: string;
  /** Mock or API row version for sorting and optimistic updates */
  updatedAtISO: string;
  /** Optional checklist item counts for TaskCard progress strip (`subSteps` field name retained for API compatibility) */
  subSteps?: { completed: number; total: number };
}
